<template>
  <div class="h100vh-116">
    <div class="h100vh-116 h-scroll">
      <ejs-grid ref='grid' height='calc(100% - 120px)' :dataSource="data" :allowResizing='true' :rowDeselected='getChooseCount' :rowSelected='getChooseCount'>
        <e-columns>
          <e-column type='checkbox' headerText='imsi' width='30' textAlign='Center'></e-column>
          <e-column field='imsi' headerText='IMSI' width='150' textAlign='Center'></e-column>
          <e-column field='ueAlias' :headerText='$t("UE.ue_alias")' width='150' textAlign='Center'></e-column>
          <e-column field='stationId' :headerText='$t("UE.ue_bs_id")' width='150' textAlign='Center'></e-column>
          <e-column field='stationAlias' :headerText='$t("UE.ue_bs_name")' width='150' textAlign='Center'></e-column>
          <e-column field='ip4' :headerText='$t("UE.ue_ip")' width='150' textAlign='Center'></e-column>
          <e-column field='data1' :headerText='$t("UE.ue_ul_Traffic")' width='150' textAlign='Center'></e-column>
          <e-column field='data2' :headerText='$t("UE.ue_dl_Traffic")' width='150' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <CustomDialog ref='qryUeDetailPage' :element='dialog.element.eleQryUeDetail' :styles='dialog.styles' :messages='dialog.messages.qryUeDetail'>
      <template v-slot:dialog-content>
        <UeDetailDialog ref='qryUeDetail'></UeDetailDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../common/CustomDialog';
import UeDetailDialog from './UeDetailDialog';
import { EventBus } from '../../plugins/eventBus';

export default {
  name: 'UETable',
  components: {
    CustomDialog,
    UeDetailDialog
  },
  data() {
    return {
      data: {},
      imsi: '',
      node: '',
      msgid: 17223,
      neid: '',
      dialog: {
        styles: {
          width: '60%',
          height: '85%',
          visible: false,
          model: true
        },
        element: {
          eleQryUeDetail: {
            target: this.$refs.UeTable,
            refName: 'eleQryUeDetail',
            buttonGroup: [
              { click: this.closeQryUeDetailPage, buttonModel: { content: this.$t('UE.ueCancell') } }
            ],
            title: this.$t('UE.ueDetailData'),
            isClose: true
          }
        },
        messages: {
          qryUeDetail: {
            title: this.$t('UE.ueDetailData')
          }
        }
      },
      page: {
        pageNo: '1',
        pageSize: '0',
        totalCount: '0',
        pageCount: '0'
      },
      queryConditions: {
        keywords: '' // 模糊查询关键字
      }
    };
  },
  methods: {
    /*  getGridUEData(node) {
      /!* if (this.checkNode) {
        console.log('网元校验失败');
      } *!/
      this.node = node;
      const $this = this;
      /!* let qryParams = null;
      qryParams = {
        neid: node.id,
        imsis: ''
      }; *!/
      const imsis = '';
      this.$axios.get(`/lte/ems/ltesubs/imsiauthkey/queryUEState.html?imsis=${imsis}&neid=${node.id}`).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.resultlist;
      });
    }, */
    getGridUEData(node) {
      const imsiListData = [];
      let imsiCount = 0;
      if (this.queryConditions.keywords !== '') {
        const imsiArr = this.queryConditions.keywords.split(',');
        imsiCount = imsiArr.length;
        imsiArr.forEach((value, index) => {
          const imsiObj = {
            imsi: value
          }
          imsiListData.push(imsiObj);
        });
      }

      const voData = {
        count: imsiCount,
        imsiList: imsiListData
      };
      if (node !== undefined) {
        this.node = node;
        this.neid = node.id;
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('UE.pleaseSelectNe') });
        return;
      }
      const $this = this;
      const params = {
        vo: voData,
        info: {
          msgid: $this.msgid,
          neid: $this.neid
          // todo neid: this.node.id
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: imsiCount
        }
      };
      // lte/ems/ltesubs/imsiauthkey/queryUEState.html
      this.$axios.post('/lte/ems/subscriber/epcunms/requestCommon', params).then((response) => {
        const res = response.data.resultVal;
        if (response.status === 200 && res !== null) {
          $this.data = res.resultlist;
          $this.page.totalCount = res.countrsp;
          EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
    },
    closeQryUeDetailPage() {
      this.$refs.qryUeDetailPage.close();
    },
    checkNode() {
      // 判断是否选择网元、网元是否在线
    },
    getDetailUEData() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('UE.ueSelectDatas') });
        return false;
      }
      if (selectedRecords.length > 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('UE.ueSelectOneData') });
        return false;
      }
      this.imsi = selectedRecords[0].imsi;
      const $this = this;
      let qryParams = null;
      const imsiListData = [];
      const imsiObj = {
        imsi: this.imsi
      }
      imsiListData.push(imsiObj);
      const voData = {
        count: selectedRecords.length,
        imsiList: imsiListData
      };
      qryParams = {
        vo: voData,
        info: {
          msgid: $this.msgid,
          neid: $this.neid
          // todo neid: this.node.id
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: selectedRecords.length
        }
      };
      $this.$refs.qryUeDetail.$refs.ueChart.queryData(qryParams);
      $this.$refs.qryUeDetail.$refs.ueCameraTable.queryData(qryParams);

      this.$refs.qryUeDetailPage.show();
      return true;
    },
    getChooseCount() {
    }
  }
};
</script>

<style scoped>

</style>
